import { Component, OnInit, HostBinding, Output, EventEmitter, Input, ViewChild, TemplateRef, Optional, ChangeDetectorRef, LOCALE_ID, Inject } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { DialogComponent } from '@farris/ui-dialog';
import { MessagerService } from '@farris/ui-messager';
import { DatagridComponent } from '@farris/ui-datagrid';
import { LookupGridComponent, PickedResult } from '@farris/ui-lookup';
import { Observable, of } from 'rxjs';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'app-jump-scope',
  templateUrl: './jump-scope.component.html',
  styleUrls: ['./jump-scope.component.css'],
  providers: [
     WfLocalePipe,
  ]
})
export class JumpScopeComponent implements OnInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input()
  set value(data: any) {
    if (data) {
      this.category = data.Category;
      this.defaultType = data.DefaultType;
      // 取到DefaultActivity的节点Id，遍历出Name绑定到radiogroup上去（defaultacty）
      const acty: string = data.DefaultActivity;
      if (acty != null) {
        for (const act of this.uistate.allActList) {
          if (act.Id === acty) {
            this.defaultacty = act.Name;
          }
        }
      }
      // 取到DestinationActivities的节点Id，遍历出Id和Name绑定到radiogroup上去（actis）
      const strs: string[] = data.DestinationActivities;
      if (strs && strs.length > 0) {
        for (const str of strs) {
          const name = this.uistate.allActList.filter(act => act.Id === str)[0].Name;
          // const acti = { Id: str, Name: name };
          this.actis.push(name);
        }
      }
    } else {
      this.category = 'OutConnectNode';
      this.defaultType = 'FirstNode';
    }
  }

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  modalConfig = {
    title: this.localePipe.transform('component.jumpScope.targetNodeOptions'),
    width: 520,
    height: 460,
    showButtons: true
  };
  // 活动节点表信息============================================
  @ViewChild('allActisTable') allActisTable: LookupGridComponent;
  @ViewChild('allActisDialog') allActisDialog: DialogComponent;
  @ViewChild('actTable') actTable: DatagridComponent;
  @ViewChild('lookup') lookup: LookupGridComponent;
  @ViewChild('userActisDialog') userActis: LookupGridComponent;

  cols = [
    { title: this.localePipe.transform('component.jumpScope.name'), field: 'Name', width: 60, searchField: 'Name' },
    { title: 'ID', field: 'Id', width: 90, searchField: 'Id' }];
  // ==========================================================
  actis = [];
  fullActis = [];
  defaultacty = '';
  categoryListItems = [
    { value: 'OutConnectNode', name: this.localePipe.transform('component.jumpScope.outConnectNode')},
    { value: 'Global', name: this.localePipe.transform('component.jumpScope.global')},
    { value: 'AfterNodes', name: this.localePipe.transform('component.jumpScope.afterNodes')},
    { value: 'SpecifiedSet', name: this.localePipe.transform('component.jumpScope.specifiedSet') }];
  category = '';
  defaultType = '';
  defaultTypeListItems = [
    { value: 'FirstNode', name: this.localePipe.transform('component.jumpScope.firstNode')},
    { value: 'NullNode', name: this.localePipe.transform('component.jumpScope.nullNode')},
    { value: 'SpecifyNode', name: this.localePipe.transform('component.jumpScope.specifyNode') }];
  defaultActivity = '';
  pageInfo = {
    pageIndex: 1,
    pageList: [10, 20, 30, 50],
    pageSize: 20
  };
  outConnectNode: true;
  total: number;
  constructor(
    public uistate: ProcessDesignerUIState,
    private message: MessagerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe
    ) {
      this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
     }

  ngOnInit() {
  }

  clickOK() {
    if (this.validator()) {
      let value;
      const list = [];
      // 重新打开设置界面，没有进行节点配置的情况（DefaultActivity）
      if ( this.defaultActivity === '' && this.defaultacty !== '') {
        for (const defAct of this.uistate.allActList) {
          if (defAct.Name === this.defaultacty) {
            this.defaultActivity = defAct.Id;
          }
        }
      }
      // 重新打开设置界面，没有进行节点配置的情况（DestinationActivities）
      if (this.fullActis.length === 0 && this.actis.length > 0) {
        for (const act of this.actis) {
          for (const allAct of this.uistate.allActList) {
            if (act === allAct.Name) {
              list.push(allAct.Id);
            }
          }
        }
      } else if (this.category === 'SpecifiedSet' && this.fullActis && this.fullActis.length > 0) {
        // 附加节点的id传给模型上的DestinationActivities
        this.fullActis.forEach(act => list.push(act.Id));
      }
      value = {
        Category: this.category,
        DefaultType: this.defaultType,
        DefaultActivity: this.defaultActivity,
        DestinationActivities: list,
      };
      const object = { value, parameters: null };
      this.submitModal.emit(object);
    }
  }

  clickCancel() {
    this.closeModal.emit();
  }

  private validator(): boolean {
    if (!this.category) {
      this.message.warning(this.localePipe.transform('component.jumpScope.noSetTargetNode'));
      return false;
    }
    // if (this.category === 'SpecifiedSet' && Object.prototype.isPrototypeOf(this.actis)) {
    //   this.message.info('尚未选择附加节点，请了解！');
    //   return false;
    // }
    if (this.defaultType === 'SpecifyNode' && this.defaultacty === '') {
      this.message.warning(this.localePipe.transform('component.jumpScope.noSetSpecifyNode'));
      return false;
    }
    return true;
  }

  searchDefault(arg: any) {
    this.pageInfo.pageIndex = arg.pageInfo.pageIndex;
    this.pageInfo.pageSize = arg.pageInfo.pageSize;
    const search = arg.search;

    this.loadDefault(search);
  }

  loadDefault(search?: { field: string, value: string}) {
    const start = (this.pageInfo.pageIndex - 1) * this.pageInfo.pageSize;
    const end = start + this.pageInfo.pageSize;
    let items = [];
    if (search && search.value) {
      if (search.field === '*') {
        items = this.uistate.allActList.filter(i => i.Name.indexOf(search.value) > -1 || i.Id.indexOf(search.value) > -1);
      } else {
        items = this.uistate.allActList.filter(f => f[search.field].indexOf(search.value) > -1);
      }
    } else {
      items = this.uistate.allActList;
    }
    this.total = items.length;
    // this.items = items;
    if(items){
      this.allActisTable.componentRef.instance.loadData({
        data: items
      });
    }
  }

  searchSelect(arg: any) {
    this.pageInfo.pageIndex = arg.pageInfo.pageIndex;
    this.pageInfo.pageSize = arg.pageInfo.pageSize;
    const search = arg.search;

    this.loadSelect(search);
  }

  loadSelect(search?: { field: string, value: string}) {
    const start = (this.pageInfo.pageIndex - 1) * this.pageInfo.pageSize;
    const end = start + this.pageInfo.pageSize;
    let items = [];
    if (search && search.value) {
      if (search.field === '*') {
        items = this.uistate.allActList.filter(i => i.Name.indexOf(search.value) > -1 || i.Id.indexOf(search.value) > -1);
      } else {
        items = this.uistate.allActList.filter(f => f[search.field].indexOf(search.value) > -1);
      }
    } else {
      items = this.uistate.allActList;
    }
    this.total = items.length;
    // this.items = items;
    if(items){
      this.userActis.componentRef.instance.loadData({
        data: items
      });
    }
  }

  actisSelect = (rowData): Observable<PickedResult> => {
    // 附加节点的帮助后事件，把选中的数据赋给fullActis（此处处理的目的是为了显示Name同时取Id值）
    // console.log(rowData);
    this.fullActis = rowData;
    return of({
      closeDialog: true
    });
  }

  defaultActivitySelect = (rowData): Observable<PickedResult> => {
    // 默认节点的帮助后事件，把选中的id赋给defaultActivity（此处处理的目的是为了显示Name同时取Id值）
    this.defaultActivity = rowData.Id;
    return of({
      closeDialog: true
    });
  }

  deleteRow() {
    if (this.actTable.selectedRow && this.actTable.selectedRow.data) {
      const i = this.actis.findIndex(d => d.id === this.actTable.selectedRow.data.id);
      this.actis.splice(i, 1);
      this.actTable.loadData(this.actis);
    } else {
      this.message.info(this.localePipe.transform('component.jumpScope.selectedRow'));
    }
  }
}
export class JumpScopeConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(): string {
    return this.localePipe.transform('component.jumpScope.set');
  }
}

